<!--
 * @Author: your name
 * @Date: 2021-01-14 16:43:34
 * @LastEditTime: 2022-09-28 11:35:24
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/ManageCenterContent/index.vue
-->
<style scoped lang="sass">
.manage_center_container

.locale_selectors
  display: flex
  align-items: center
  gap: 8px
  padding: 0 0 12px
  margin-bottom: 12px
  border-bottom: 1px solid rgba(50, 56, 62, 0.1)

.locale_trigger_btn
  display: flex
  align-items: center
  padding: 8PX 14PX
  background: transparent
  border-radius: 20PX
  cursor: pointer
  border: 1PX solid rgba(50, 56, 62, 0.15)
  gap: 6PX

  &:active
    opacity: 0.7

  .flag_icon
    width: 18PX
    height: 18PX
    border-radius: 50%
    flex-shrink: 0
    object-fit: cover

  .trigger_text
    font-size: 13PX
    font-weight: 600
    color: var(--menu-primary-text-colour, #333)
    white-space: nowrap

.each_menu_item
  position: relative
  height: 40PX
  margin-bottom: 10px

.icon
  height: 100%
  width: 40PX
  display: flex
  justify-content: center
  align-items: center
  color: var(--menu-primary-text-colour) !important

.title
  font-size: 14px
  color: var(--menu-primary-text-colour) !important

.icon_container
  height: 100%
  display: flex
  justify-content: center
  align-content: center
  margin-right: 35PX

.mask
  position: absolute
  top: 0
  height: 100%
  width: 100%

.content_container
  display: flex
  align-items: center
  height: 100%
  z-index: 3

.choosed_text
  color: var(--menu-primary-background-colour) !important
  opacity: 1 !important

.choosed
  background: var(--menu-primary-background-colour)
  opacity: .1
  border-radius: 5PX
</style>

<style lang="sass">
// Unscoped: override flag-icons default sizing inside this component
.manage_center_container .fi
  width: 1em
  height: 1em
  background-size: cover
  border-radius: 50%
</style>

<template lang="pug">
.manage_center_container
  //- Language & Currency trigger buttons at top of drawer
  //- 抽屉顶部的语言和货币选择器触发按钮
  .locale_selectors(v-if="hasMultipleLanguages || hasMultipleCurrencies")
    .locale_trigger_btn(v-if="hasMultipleLanguages" @click="$emit('openLanguageModal')")
      span.flag_icon.fi.fis(:class="'fi-' + getLanguageCountryCode()")
      span.trigger_text {{ currentLanguageData.name }}
    .locale_trigger_btn(v-if="hasMultipleCurrencies" @click="$emit('openCurrencyModal')")
      span.flag_icon.fi.fis(:class="'fi-' + getCurrencyCountryCode()")
      span.trigger_text {{ currentCurrencyData.name }} · {{ currentCurrencyData.code }}
  .each_menu_item.p(
    v-if="item.show && showTab(item.page)"
    v-for="(item, index) in menuList"
    @click="jumpToPage(item.page, index)"
  )
    .content_container
      .icon_container
        icon.icon.o7(
          size="24"
          :color="choosedIndex === index ? backgroundColor : ''"
          :style="{ opacity: choosedIndex === index ? '1 !important' : '' }"
        ) {{ item.icon }}
      .title.o7.b.ls1(
        :class="{'choosed_text': choosedIndex === index}"
      ) {{ localizedTitle(item.title) }}
    .mask(
      :class="{'choosed': choosedIndex === index}"
    )
  //- 「保存到桌面」手动入口：自动弹窗每店只弹一次，错过/拒绝过的顾客从这里再打开。
  //- 只在弹窗组件实际挂载且可用的页面显示（venue-home 无桌号 + 后端开关 + 支持的平台）
  .each_menu_item.p(
    v-if="showAddToHomeScreenEntry"
    @click="openAddToHomeScreen"
  )
    .content_container
      .icon_container
        icon.icon.o7(size="24") add_to_home_screen
      .title.o7.b.ls1 {{ addToHomeScreenTitle }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import { ANIMATED_TIME_MS } from 'modules/manageCenterContent'
import { t } from '@/utils/language'
import { canPromptAddToHomeScreenHere } from '@/utils/addToHomeScreen/platform'
import { A2HS_MANUAL_OPEN_EVENT, isManualEntryRoute } from '@/utils/addToHomeScreen/manualEntry'
// Emoji flag to country code mapping (fallback when countryCode not in data)
const EMOJI_TO_CODE = {
  '\u{1F1E6}\u{1F1FA}': 'au',
  '\u{1F1FA}\u{1F1F8}': 'us',
  '\u{1F1EA}\u{1F1FA}': 'eu',
  '\u{1F1EC}\u{1F1E7}': 'gb',
  '\u{1F1E8}\u{1F1F3}': 'cn',
  '\u{1F1EF}\u{1F1F5}': 'jp',
  '\u{1F1F3}\u{1F1FF}': 'nz',
  '\u{1F1F8}\u{1F1EC}': 'sg',
  '\u{1F1ED}\u{1F1F0}': 'hk',
  '\u{1F1E8}\u{1F1E6}': 'ca',
  '\u{1F1EB}\u{1F1F7}': 'fr',
}

@Component({
  props: {
    userHasTab: {
      type: Boolean
    },

    menuList: {
      type: Array
    }
  },

  computed: {
    ...mapState(['venueId']),
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo
    }),
    ...mapGetters('language', ['hasMultipleLanguages']),
    ...mapGetters('currencySettings', ['hasMultipleCurrencies']),
    ...mapState('language', {
      currentLanguage: 'currentLanguage',
      supportedLanguages: 'supportedLanguages',
    }),
    ...mapState('currencySettings', {
      currentCurrency: 'currentCurrency',
      supportedCurrencies: 'supportedCurrencies',
    }),

    currentLanguageData() {
      const langs = this.supportedLanguages || []
      return langs.find(l => l.code === this.currentLanguage) || { code: 'en', name: 'English', flag: '\u{1F1E6}\u{1F1FA}', countryCode: 'au' }
    },

    currentCurrencyData() {
      const currs = this.supportedCurrencies || []
      return currs.find(c => c.code === this.currentCurrency) || { code: 'AUD', symbol: '$', name: 'Australian Dollar', flag: '\u{1F1E6}\u{1F1FA}', countryCode: 'au' }
    },

    backgroundColor() {
      return this.$store.state.app.color.menu_primary_background_colour + ' !important'
    },

    showCreateTab() {
      return this.menuList[3].show
    },

    tabInfo() {
      return this.$store.getters.tabInfo(this.venueId)
    },

    // SP 模式检测
    isSpMode() {
      return this.$route.path.includes('/v/sp/') || this.$route.meta?.isSpMode === true
    },

    // 根据 SP 模式返回正确的路径前缀
    venuePathPrefix() {
      return this.isSpMode ? `/v/sp/${this.venueId}` : `/v/${this.venueId}`
    },

    // 「保存到桌面」入口：后端按店开关（vuex，venue-home 加载后 commit）
    // + 支持的平台 + 弹窗组件实际挂载的路由，三关都过才显示
    showAddToHomeScreenEntry() {
      return !!this.$store.state.enableAddToHomeScreen &&
        isManualEntryRoute(this.$route.name) &&
        canPromptAddToHomeScreenHere()
    },

    addToHomeScreenTitle() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return t('a2hs_menu_entry', 'Add to home screen')
    }
  },

  watch: {
    showCreateTab(val) {
      if (!val) this._restChoosedIndex()
    },
    $route (to, from) {
      if (to.path) {
        if (to.path.indexOf('order-history') >= 0) {
          this.choosedIndex = 1
        } else if (to.path.indexOf('tab-admin') >= 0) {
          this.choosedIndex = 2
        } else {
          this.choosedIndex = 0
        }
      }
    }
  }
})

class ManageCenterContent extends Vue {
  choosedIndex = 0

  // Menu title translation mapping / 菜单标题翻译映射
  localizedTitle(title) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const TITLE_KEYS = {
      Menu: 'menu',
      'Order history': 'order_history',
      'Start a tab': 'start_a_tab',
      'Manage Tab': 'manage_tab',
    }
    const key = TITLE_KEYS[title]
    return key ? t(key, title) : title
  }

  getLanguageCountryCode() {
    const item = this.currentLanguageData
    if (item.countryCode) return item.countryCode
    if (item.flag && EMOJI_TO_CODE[item.flag]) return EMOJI_TO_CODE[item.flag]
    return 'au'
  }

  getCurrencyCountryCode() {
    const item = this.currentCurrencyData
    if (item.countryCode) return item.countryCode
    if (item.flag && EMOJI_TO_CODE[item.flag]) return EMOJI_TO_CODE[item.flag]
    return 'au'
  }

  showTab(val) {
    const isOnline = this.$store.state.app.isOnline
    const { path, query } = this.$route
    const isTakeaway = path.includes('/v/o/') || path.includes('/online/')
    return !((isOnline || (isTakeaway && 'ta' in query)) && (val === 'tab-menu' || val === 'start-tab'))
  }

  jumpToPage(page, index) {
    this.choosedIndex = index
    setTimeout(() => {
      this._jumpToOtherPage(page)
    }, ANIMATED_TIME_MS)
    this._closeLeftPopupDialog()
  }

  // 关抽屉，等收起动画走完再请求弹窗打开（与 jumpToPage 同一节奏），
  // 由挂载中的 AddToHomeScreen 组件响应 $root 事件
  openAddToHomeScreen() {
    setTimeout(() => {
      this.$root.$emit(A2HS_MANUAL_OPEN_EVENT)
    }, ANIMATED_TIME_MS)
    this._closeLeftPopupDialog()
  }

  _restChoosedIndex() {
    this.choosedIndex = 0
  }

  _jumpToOtherPage(page) {
    if (page === 'start-tab') {
      this._jumpToContactDetail()
    } else if (page === 'venue-home') {
      this._jumpToIndex()
    } else if (page === 'order-history') {
      this._jumpToHistory()
    } else if (page === 'tab-menu') {
      this._setTabPassCode()
      this._jumpToManageTab()
    }
  }

  _setTabPassCode() {
    const passCode = this.tabInfo.currentTab.phone.slice(-4)
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', passCode)
  }

  _jumpToManageTab() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabInfo.currentTab.id}/menu`
    })
  }

  _jumpToHistory() {
    const routerName = this.$route.name
    const ls = [
      'venue-home-table',
      'venue-home-pick',
      // SP 模式的路由
      'venue-home-table-sp',
      'venue-home-table-sp-alt',
      'venue-home-no-table-sp',
      'venue-home-pick-sp'
    ]
    if (ls.includes(routerName)) {
      this.$router.push({
        path: `${this.venuePathPrefix}/order-history`,
        query: {
          fromPage: routerName
        }
      })
    } else {
      if (routerName === 'order-history' || routerName === 'order-history-sp') {
        // currenty page === order-history
        // do nothing
      } else {
        this.$router.push(`${this.venuePathPrefix}/order-history`)
      }
    }
  }

  _jumpToContactDetail() {
    this.$router.push(`${this.venuePathPrefix}/contact-details`)
  }

  _jumpToIndex() {
    const tableNumber = this.routerInfo.number || this.$route.query.tableNumber
    if (tableNumber) {
      this.$router.push(`${this.venuePathPrefix}/home/t/${tableNumber}`)
    } else {
      this.$router.push(`${this.venuePathPrefix}/home/p`)
    }
  }

  _closeLeftPopupDialog() {
    this.$emit('closeManageCenterDialog')
  }
}

export default ManageCenterContent
</script>
